import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { ContractData, ContractMovementData } from "@/lib/coach-manager/types";

function serialNoOf(row: ContractData | ContractMovementData): number {
  return "ContractMovementDataTitleSerialNo" in row
    ? row.ContractMovementDataTitleSerialNo
    : row.ContractDataTitleSerialNo;
}

/**
 * Shared table for `ContractData`/`ContractMovementData` rows — both share
 * the same `{ TextValue, NumberValue, MoneyValue, DateValue, YesNoValue }`
 * shape (only one field is semantically meaningful per row, selected by a
 * `DataType` on the row's title definition, which this app doesn't fetch —
 * see `types.ts`'s comment on this), so every value column is shown as-is.
 */
export function DataValuesTable({ rows }: { rows: (ContractData | ContractMovementData)[] }) {
  if (rows.length === 0) return null;

  return (
    <DataTable
      headers={[
        { label: "Title #" },
        { label: "Text" },
        { label: "Number" },
        { label: "Money" },
        { label: "Date" },
        { label: "Yes/No" },
      ]}
    >
      {rows.map((row) => (
        <tr key={serialNoOf(row)} className="border-b last:border-b-0">
          <td className="px-4 py-2">{serialNoOf(row)}</td>
          <td className="px-4 py-2">{formatCellValue(row.TextValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.NumberValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.MoneyValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.DateValue)}</td>
          <td className="px-4 py-2">{formatCellValue(row.YesNoValue)}</td>
        </tr>
      ))}
    </DataTable>
  );
}
